import { html, View } from 'rune-ts';
import { type ProgressProps } from './index';
import klass from './Progress.module.scss';
import { font } from '@services/MarppleShop/shared/typography';

export class ProgressPercentage extends View<ProgressProps> {
  protected override template() {
    const { start, end, klass: custom_klass, font: font_klass, auto = true } = this.data;
    return html`
      <span class="${klass.progress_percentage} ${font('16_medium', '12_medium')} ${custom_klass || ''}">
        <b class="${klass.progress_percentage_value} ${font_klass || ''}"
          >${auto ? start : Math.round(Number(end)).toLocaleString()}</b
        >
        <b class="${klass.progress_percentage_suffix} ${font_klass || ''}">%</b>
      </span>
    `;
  }
}
